import { createApi } from '@reduxjs/toolkit/dist/query/react';
import Util from '../../../util/Util';
import axiosBaseQuery from '../../../axios/axiosBaseQuery';
import { CommanderControlUnitChannelFilterLogicalObject } from './util/filter/filter.model';
import convertPromiseToQueryReturnValue from '../../../axios/convertPromiseToQueryReturnValue';
import { MonitoringCalls } from './MonitoringCalls';

export const MonitoringAPI = createApi({
  reducerPath: 'monitoringAPI',
  // 60 seconds
  keepUnusedDataFor: 60,
  baseQuery: axiosBaseQuery(),
  tagTypes: ['monitoring-sensordata', 'monitoring-events'],
  endpoints(build) {
    return {
      getSensordataByDeviceID: build.query({
        queryFn: async (params: {
          deviceId: string;
          start: number;
          end: number;
          commanderFilterObject: CommanderControlUnitChannelFilterLogicalObject;
          includeCloudGenerated?: boolean;
        }) => {
          const {
            deviceId,
            start,
            end,
            commanderFilterObject,
            includeCloudGenerated,
          } = params;
          const response = new MonitoringCalls().getSensordataByDeviceID(
            deviceId,
            start,
            end,
            commanderFilterObject,
            includeCloudGenerated
          );
          return await convertPromiseToQueryReturnValue(response);
        },
      }),
      getEventsByID: build.query({
        queryFn: async (params: {
          deviceId: string;
          start: number;
          end: number;
          commanderFilterObject: CommanderControlUnitChannelFilterLogicalObject;
        }) => {
          const { deviceId, start, end, commanderFilterObject } = params;
          const response = new MonitoringCalls().getEventsByID(
            deviceId,
            start,
            end,
            commanderFilterObject
          );

          return await convertPromiseToQueryReturnValue(response);
        },
      }),
      getConnectionInfoByID: build.query({
        queryFn: async (params: {
          deviceId: string;
          start: number;
          end: number;
          channels: string[];
        }) => {
          const { deviceId, start, end, channels } = params;
          const response = new MonitoringCalls().getConnectionInfoByID(
            deviceId,
            start,
            end,
            channels
          );

          return await convertPromiseToQueryReturnValue(response);
        },
      }),
      getCurrentEventsByID: build.query({
        queryFn: async (params: { deviceId: string }) => {
          const { deviceId } = params;
          const response = new MonitoringCalls().getCurrentEventsByID(deviceId);

          return await convertPromiseToQueryReturnValue(response);
        },
      }),
      getCurrentSensorDataByID: build.query({
        queryFn: async (params: { deviceId: string }) => {
          const { deviceId } = params;
          const response = new MonitoringCalls().getCurrentSensorDataByID(
            deviceId
          );

          return await convertPromiseToQueryReturnValue(response);
        },
      }),
    };
  },
});

export default MonitoringAPI;
